import { render, staticRenderFns } from "./PanelDashboardProfile.vue?vue&type=template&id=0ee9bc04&"
import script from "./PanelDashboardProfile.vue?vue&type=script&lang=js&"
export * from "./PanelDashboardProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports